import { Modal } from 'react-bootstrap';
import { useIntl } from 'react-intl';
import { useState } from 'react';
import clsx from 'clsx';
import { KTSVG } from '../../../../../../_metronic/helpers';
import { siteIntelligenceServiceLabel } from '../../../mappings';
import { UsePageDataManagerResult } from '../hooks/usePageDataManager';
import { AddInOutboundLinks } from '../form/AddInOutboundLinks';

type Props = {
  data: any;
  show: boolean;
  handleClose: () => void;
  handleUpdate: UsePageDataManagerResult['updateField'];
  handleSave: UsePageDataManagerResult['saveService'];
};

const AddInOutboundLinksModal: React.FC<Props> = ({
  data,
  show,
  handleClose,
  handleUpdate,
  handleSave,
}) => {
  const intl = useIntl();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  return (
    <Modal
      id='add_inoutbound_links_modal'
      aria-hidden={!show}
      tabIndex={-1}
      dialogClassName='modal-dialog-centered mw-1000px h-auto'
      show={show}
    >
      <div className={clsx('container-xxl px-5', isLoading && 'overlay overlay-block')}>
        <div className='modal-body'>
          <div className='overlay-wrapper'>
            {/* Header */}
            <div className='w-100 d-flex justify-content-between mt-5 mb-3'>
              <div>
                <h1 className='d-flex align-items-center text-dark fw-bolder fs-1 ms-md-12'>
                  Add {siteIntelligenceServiceLabel[data.service]} Links
                </h1>
              </div>
              <div className='btn btn-icon btn-sm btn-light-primary me-md-9' onClick={handleClose}>
                <KTSVG className='svg-icon-2' path='/media/icons/duotune/arrows/arr061.svg' />
              </div>
            </div>
            <AddInOutboundLinks
              data={data}
              onClose={handleClose}
              onUpdate={handleUpdate}
              onSave={handleSave}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
            />
          </div>

          {/* Loading overlay blocker */}
          {isLoading && <div className='overlay-layer bg-white bg-opacity-10 z-index-3'></div>}
        </div>
      </div>
    </Modal>
  );
};
export { AddInOutboundLinksModal };
